import React, { useState, useEffect } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import Image1Active from '../../assets/placeholder Fill (23).png'
import Image2Active from '../../assets/placeholder Fill (24).png'
import Image3Active from '../../assets/placeholder Fill (25).png'
import Image4Active from '../../assets/placeholder Fill (26).png'
import Image1InActive from '../../assets/placeholder Fill (27).png'
import Image2InActive from '../../assets/placeholder Fill (28).png'
import Image3InActive from '../../assets/placeholder Fill (29).png'
import Image4InActive from '../../assets/placeholder Fill (30).png'
import InfoImage from '../../assets/placeholder Fill (19).png'
import InfoInactive from '../../assets/placeholder Fill (20).png'
import VerifyImage from '../../assets/verified.png'
import NotVerified from '../../assets/cross.png'
import noData from '../../assets/nodata.png'
import { getAmuAnalysis, getAMUCrifReport } from '../../Access/ActionCreator';
import moment from 'moment';
import AlertPopup from '../common/AlertPopup';
import Loader from '../common/Loader'
import html2pdf from 'html2pdf.js';

const found = true;
export default function CrifReportPage({ BackHandler }) {

  const [loader, setLoader] = useState(false)
  const [currentView, setcurrentView] = useState("detailed")
  const [analysisData, setanalysisData] = useState([])
  const [crifData, setcrifData] = useState([])
  const [showReportPopup, setshowReportPopup] = useState(false)
  const [popup, setPopup] = useState({
    show: false,
    severity: "",
    message: "",
  })



  useEffect(() => {
    getAmuAnalysisFunction()
    setTimeout(() => {
      handleRegenerate()
    }, 2000)
  }, [])

  const getParsedData = (type) => {
    let d = window.sessionStorage.getItem("SearchData")
    let SearchedData = JSON.parse(d)
    let returnData = ""
    if (type === "name") {
      returnData = (SearchedData?.firstName ?? "") + " " + (SearchedData?.middleName ?? "") + " " + (SearchedData?.lastName ?? "")
    }
    return returnData;

  }

  const getAmuAnalysisFunction = () => {
    let d = window.sessionStorage.getItem("SearchData")
    let SearchedData = JSON.parse(d)
    const data = {
      "userId": "",
      "dateOfBirth": moment(SearchedData?.dateOfBirth).format("DD-MM-YYYY") ?? "",
      "firstName": SearchedData?.firstName ?? "",
      "lastName": SearchedData?.lastName ?? "",
      "middleName": SearchedData?.middleName ?? "",
      "emailId": SearchedData?.emailId ?? "",
      "panNumber": SearchedData?.panNumber ?? "",
      "mobileNumber": SearchedData?.mobileNumber ?? "",
      "city": SearchedData?.city ?? "",
      "state": SearchedData?.state ?? "",
      "pincode": SearchedData?.pincode ?? "",
      "address": SearchedData?.address ?? "",
      "loanAmount": SearchedData?.loanAmount ?? "",
      "accountNumber": SearchedData?.accountNumber ?? "",
      "dealerName": SearchedData?.dealerName ?? "",
      "dealerLocation": SearchedData?.dealerLocation ?? "",
    }
    setLoader(true)
    getAmuAnalysis(data, (callback) => {
      setLoader(false)
      if (callback) {
        setanalysisData(callback)
      } else {
        setPopup({ show: true, severity: "error", message: "Error: Please Try Again" })
      }
      setTimeout(() => setPopup({ show: false, severity: "", message: "" }), 4000);
    })


  }



  const getCrifValueWiseData = (obj, type, searchType) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(obj, 'text/html');

    if (type !== '' && type !== undefined && type !== null) {
      let headerElem = [];
      let valueElem = [];
      if (searchType == 'dataHeader') {

        headerElem = doc.querySelectorAll('.dataHeader');
        valueElem = doc.querySelectorAll('.dataValue');
      } else if (searchType == 'dataHeader1') {
        headerElem = doc.querySelectorAll('.dataHeader1');
        valueElem = doc.querySelectorAll('.dataValue1');
      }


      for (let i = 0; i < headerElem.length; i++) {
        const headerElement = headerElem[i];
        const valueElement = valueElem[i];

        if (headerElement.textContent.trim() === type) {
          const dateOfRequestValue = valueElement.textContent;
          return dateOfRequestValue;
        }
      }
    }
  }

  const handleRegenerate = () => {
    let d = window.sessionStorage.getItem("SearchData")
    let SearchedData = JSON.parse(d)
    const data = {
      "userId": "",
      "dateOfBirth": moment(SearchedData?.dateOfBirth).format("DD-MM-YYYY") ?? "",
      "firstName": SearchedData?.firstName ?? "",
      "lastName": SearchedData?.lastName ?? "",
      "middleName": SearchedData?.middleName ?? "",
      "emailId": SearchedData?.emailId ?? "",
      "panNumber": SearchedData?.panNumber ?? "",
      "mobileNumber": SearchedData?.mobileNumber ?? "",
      "city": SearchedData?.city ?? "",
      "state": SearchedData?.state ?? "",
      "pincode": SearchedData?.pincode ?? "",
      "address": SearchedData?.address ?? "",
      "loanAmount": SearchedData?.loanAmount ?? "",
      "accountNumber": SearchedData?.accountNumber ?? "",
      "dealerName": SearchedData?.dealerName ?? "",
      "dealerLocation": SearchedData?.dealerLocation ?? "",
    }
    setLoader(true)
    getAMUCrifReport(data, (callback) => {
      setLoader(false)
      getAmuAnalysisFunction()
      if (callback == "failure") {
        setPopup({ show: true, severity: "error", message: "Failure" })
      } else {
        setcrifData(callback)
      }
      setTimeout(() => setPopup({ show: false, severity: "", message: "" }), 4000);
    })
  }

  const DownloadReport = () => {
    let d = window.sessionStorage.getItem("SearchData")
    let SearchedData = JSON.parse(d)
    const element = document.getElementById("html-renderer");

    if (!element) {
      console.error("Element not found: #html-renderer");
      return;
    }

    setLoader(true)
    element.style.height = "auto";
    element.style.overflowY = "visible";
  
    const pdfOptions = {
      margin: 10,
      filename: `CrifReport(${SearchedData?.firstName || "Unknown"} ${SearchedData?.lastName || "User"}).pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a3", orientation: "portrait" },
    };
  
    setTimeout(() => {
    html2pdf()
      .from(element)
      .set(pdfOptions)
      .save()
      .then(()=>{
        element.style.height = window?.innerWidth > 1800 ? "650px" : "450px";
        element.style.overflowY = "auto";
        setLoader(false)
      })
      .catch(()=>{
        setLoader(false)
      })
    }, 300);
  }


  return (
    <>
      <div className="CrifReportPage">
        {
          loader ?
            <Loader /> : ''
        }
        {
          popup.show ?
            <AlertPopup severity={popup.severity} message={popup.message} />
            : ''}
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-4 col-xs-12">
              <div className="BackBtnMain">
                <button className='BackBtn' onClick={() => BackHandler()}><KeyboardBackspaceIcon /></button>
              </div>
            </div>
            <div className="col-sm-4 col-xs-12">
              <div className="Heading">
                <h4>CRIF Analysis For {getParsedData("name")}</h4>
              </div>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-sm-3 col-xs-12" style={{ paddingRight: '0px' }}>
              <div className="Leftcol">
                <div className="blueBox">
                  <div className="row">
                    <div className="col-sm-6 col-xs-12" style={{ padding: '10px' }}>
                      <h5>CIBIL Score</h5>
                    </div>
                    <div className="col-sm-6 col-xs-12" style={{ padding: '10px' }}>
                      <h5>{analysisData?.finBoxDecision?.score ?? ""}</h5>
                    </div>
                    <hr />
                    <div className="col-sm-6 col-xs-12" style={{ padding: '10px' }}>
                      <h5>Decision</h5>
                    </div>
                    <div className="col-sm-6 col-xs-12" style={{ padding: '10px' }}>
                      <h5> {analysisData?.finBoxDecision?.finalDecision ?? ""}</h5>
                      <h6>{getCrifValueWiseData(analysisData?.finBoxDecision?.progress, 'Date of Request:', 'dataHeader1')}</h6>
                    </div>
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-3">
                    <div className='text-center'>
                      <img src={currentView === "obligationAmount" ? Image1Active : Image1InActive} width={"40px"} />
                    </div>
                  </div>
                  <div className="col-9">
                    <div className={`LeftText d-inine-block ${currentView === "obligationAmount" ? "active" : ""}`} onClick={() => setcurrentView("obligationAmount")}>
                      <h5>Obligation Amount</h5>
                      {analysisData && analysisData?.obligationData && analysisData?.obligationData.emiSum ?
                        <h5 style={{ color: currentView === 'obligation' ? '#2B78FF' : '#000', fontWeight: '700' }}> INR {analysisData && analysisData?.obligationData ? Math.round(analysisData?.obligationData?.emiSum) : 0}</h5> : <h5 className="col-sm-12 col-xs-12 text-blue text-right">N/A </h5>}

                    </div>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-3">
                    <div className='text-center'>
                      <img src={currentView === "greenFlag" ? Image2Active : Image2InActive} width={"40px"} />
                    </div>
                  </div>
                  <div className="col-9">
                    <div className={`LeftText d-inine-block ${currentView === "greenFlag" ? "active" : ""}`} onClick={() => setcurrentView("greenFlag")}>
                      <h5>Green Flag</h5>
                      {analysisData != null &&
                        analysisData != undefined &&
                        analysisData != '' && analysisData?.finBoxDecision != null && analysisData?.finBoxDecision != undefined && analysisData?.finBoxDecision != "" && analysisData?.finBoxDecision?.approve != null && analysisData?.finBoxDecision?.approve != '' && analysisData?.finBoxDecision?.approve != undefined && analysisData?.finBoxDecision?.finalDecision != 'Rejected'
                        ?
                        <div className="greenFlag">
                          <i className="fa fa-check-circle"></i> Found
                        </div>
                        :
                        <div className="redFlag">
                          <i className="fa fa-times-circle"></i> Not Found
                        </div>
                      }
                      {/* {
                        found ?
                          <div className="greenFlag">
                            <i className="fa fa-check-circle"></i> Found
                          </div>
                          : <div className="redFlag">
                            <i className="fa fa-times-circle"></i> Not Found
                          </div>
                      } */}
                    </div>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-3">
                    <div className='text-center'>
                      <img src={currentView === "yellowFlag" ? Image3Active : Image3InActive} width={"40px"} />
                    </div>
                  </div>
                  <div className="col-9">
                    <div className={`LeftText d-inine-block ${currentView === "yellowFlag" ? "active" : ""}`} onClick={() => setcurrentView("yellowFlag")}>
                      <h5>Yellow Flag</h5>
                      {analysisData != null &&
                        analysisData != undefined &&
                        analysisData != '' && analysisData?.finBoxDecision != null && analysisData?.finBoxDecision != undefined && analysisData?.finBoxDecision != "" &&
                        analysisData?.finBoxDecision?.exceptionCase != null &&
                        analysisData?.finBoxDecision?.exceptionCase != '' &&
                        analysisData?.finBoxDecision?.exceptionCase != undefined
                        ?
                        <div className="greenFlag">
                          <i className="fa fa-check-circle"></i> Found
                        </div>
                        :
                        <div className="redFlag">
                          <i className="fa fa-times-circle"></i> Not Found
                        </div>
                      }
                      {/* {
                        found ?
                          <div className="greenFlag">
                            <i className="fa fa-check-circle"></i> Found
                          </div>
                          : <div className="redFlag">
                            <i className="fa fa-times-circle"></i> Not Found
                          </div>
                      } */}
                    </div>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-3">
                    <div className='text-center'>
                      <img src={currentView === "redFlag" ? Image4Active : Image4InActive} width={"40px"} />
                    </div>
                  </div>
                  <div className="col-9">
                    <div className={`LeftText d-inine-block ${currentView === "redFlag" ? "active" : ""}`} onClick={() => setcurrentView("redFlag")}>
                      <h5>Red Flag</h5>
                      {analysisData != null &&
                        analysisData != undefined &&
                        analysisData != '' && analysisData?.finBoxDecision != null && analysisData?.finBoxDecision != undefined && analysisData?.finBoxDecision != "" &&
                        analysisData?.finBoxDecision?.rejected != null &&
                        analysisData?.finBoxDecision?.rejected != '' &&
                        analysisData?.finBoxDecision?.rejected != undefined && analysisData?.finBoxDecision?.finalDecision == 'Rejected'
                        ?
                        <div className="greenFlag">
                          <i className="fa fa-check-circle"></i> Found
                        </div>
                        :
                        <div className="redFlag">
                          <i className="fa fa-times-circle"></i> Not Found
                        </div>
                      }
                      {/* {
                        found ?
                          <div className="greenFlag">
                            <i className="fa fa-check-circle"></i> Found
                          </div>
                          : <div className="redFlag">
                            <i className="fa fa-times-circle"></i> Not Found
                          </div>
                      } */}
                    </div>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-3">
                    <div className='text-center'>
                      <img src={currentView === "detailed" ? InfoImage : InfoInactive} width={"40px"} />
                    </div>
                  </div>
                  <div className="col-9">
                    <div className={`LeftText d-inine-block ${currentView === "detailed" ? "active" : ""}`} onClick={() => setcurrentView("detailed")} style={{ padding: '4% 0%' }}>
                      <h5>Detailed View</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-9 col-xs-12" style={{ paddingLeft: '0px' }}>
              <div className="Rightcol">



                {
                  currentView === "obligationAmount" && analysisData?.obligationData && analysisData?.obligationData?.loanReportAnalysed ?
                    <div className='' >
                      {analysisData != null &&
                        analysisData != undefined &&
                        analysisData != '' &&
                        analysisData?.obligationData?.loanReportAnalysed != null &&
                        analysisData?.obligationData?.loanReportAnalysed != '' &&
                        analysisData?.obligationData?.loanReportAnalysed != undefined ? (
                        <div className='table-new'>
                          <table className='text-center '>
                            <thead>
                              <tr>
                                <th style={{ whiteSpace: 'nowrap' }}>Account Type</th>
                                <th style={{ whiteSpace: 'nowrap' }}>OverDue Amount</th>
                                <th style={{ whiteSpace: 'nowrap' }}>Disburse Amount</th>
                                <th style={{ whiteSpace: 'nowrap' }}>Disburse Date</th>
                                <th style={{ whiteSpace: 'nowrap' }}>Account Status</th>
                                <th style={{ whiteSpace: 'nowrap' }}>Current Balance</th>
                                <th style={{ width: '50px', whiteSpace: 'nowrap' }}>Combined Payment History</th>
                                <th style={{ whiteSpace: 'nowrap' }}>Ownership</th>
                                <th style={{ whiteSpace: 'nowrap' }}>Security Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {analysisData?.obligationData != null &&
                                analysisData?.obligationData != undefined &&
                                analysisData?.obligationData != ''
                                ? analysisData?.obligationData.loanReportAnalysed.map((data, i) => {
                                  var updatedData = data.combinedPaymentHistory.replace(/\|/g, ' ');
                                  const messageType = data.disbursedAmt;
                                  const amount = data.status;

                                  // const isEmiIncluded = jsondata['obligation'] && jsondata['obligation'].some(item => (item.disbursedAmt === messageType) && (item.status === amount));

                                  return (
                                    // <tr key={i} style={{
                                    //     background: isEmiIncluded ? 'lightgreen' : 'white', cursor: 'pointer'
                                    // }} onClick={() => crfJsonData('obligation', data)}>
                                    <tr key={i}>
                                      <td>{data?.accType ?? "-"}</td>
                                      <td>{data?.overDueAmt || "-"}</td>
                                      <td>{data?.disbursedAmt || "-"}</td>
                                      <td>{data?.disburseDate ?? "-"}</td>
                                      <td>{data?.accountStatus ?? "-"}</td>
                                      <td>{data?.currentBal || "-"}</td>
                                      <td style={{ width: '50px' }}>{updatedData ?? "-"}</td>
                                      <td>{data?.ownershipInd ?? "-"}</td>
                                      <td>{data?.securityStatus ?? "-"}</td>
                                    </tr>
                                  )
                                })
                                : ''}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                    : ''}
                {currentView === 'greenFlag' ?
                  <div className='' >
                    {analysisData != null &&
                      analysisData != undefined &&
                      analysisData != '' && analysisData?.finBoxDecision != null && analysisData?.finBoxDecision != undefined && analysisData?.finBoxDecision != "" &&
                      analysisData?.finBoxDecision?.approve != null &&
                      analysisData?.finBoxDecision?.approve != '' &&
                      analysisData?.finBoxDecision?.approve != undefined && analysisData?.finBoxDecision?.finalDecision != 'Rejected' ? (
                      <div className='green-table table-new'>
                        <table className='text-center '>
                          <thead>
                            <tr>
                              <th>Account Type</th>
                              <th>OverDue Amount</th>
                              <th>Disburse Amount</th>
                              <th>Disburse Date</th>
                              <th>Account Status</th>
                              <th>Current Balance</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {analysisData != null &&
                              analysisData != undefined &&
                              analysisData != '' && analysisData?.finBoxDecision != null && analysisData?.finBoxDecision != undefined && analysisData?.finBoxDecision != ""
                              ? analysisData?.finBoxDecision?.approve.map((data, i) => {
                                const messageType = data.disburseAmount;
                                const amount = data.status;

                                // const isEmiIncluded = jsondata['greenFlag'] && jsondata['greenFlag'].some(item => (item.disburseAmount === messageType) && (item.status === amount));

                                return (
                                  <tr key={i}>
                                    <td>{data?.accountType || "-"}</td>
                                    <td>{data?.overDueAmount ?? "-"}</td>
                                    <td>{data?.disburseAmount ?? "-"}</td>
                                    <td>{data?.disburseDate || "-"}</td>
                                    <td>{data?.accountStatus || "-"}</td>
                                    <td>{data?.currentBalance ?? "-"}</td>
                                    <td>{data?.status || "-"}</td>
                                  </tr>
                                )
                              })
                              : ''}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  : ""}
                {currentView === 'yellowFlag' ?
                  <div className='' >
                    {analysisData != null &&
                      analysisData != undefined &&
                      analysisData != '' && analysisData?.finBoxDecision != null && analysisData?.finBoxDecision != undefined && analysisData?.finBoxDecision != "" &&
                      analysisData?.finBoxDecision?.exceptionCase != null &&
                      analysisData?.finBoxDecision?.exceptionCase != '' &&
                      analysisData?.finBoxDecision?.exceptionCase != undefined ? (
                      <div className='table-new'>
                        <table className='text-center '>
                          <thead>
                            <tr>
                              <th>Account Type</th>
                              <th>OverDue Amount</th>
                              <th>Disburse Amount</th>
                              <th>Disburse Date</th>
                              <th>Account Status</th>
                              <th>Current Balance</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {analysisData != null &&
                              analysisData != undefined &&
                              analysisData != '' && analysisData?.finBoxDecision != null && analysisData?.finBoxDecision != undefined && analysisData?.finBoxDecision != ""
                              ? analysisData?.finBoxDecision?.exceptionCase.map((data, i) => {
                                const messageType = data.disburseAmount;
                                const amount = data.status;


                                return (
                                  <tr key={i} >
                                    <td>{data?.accountType ?? "-"}</td>
                                    <td>{data?.overDueAmount || "-"}</td>
                                    <td>{data?.disburseAmount || "-"}</td>
                                    <td>{data?.disburseDate ?? "-"}</td>
                                    <td>{data?.accountStatus ?? "-"}</td>
                                    <td>{data?.currentBalance || "-"}</td>
                                    <td>{data?.status ?? "-"}</td>
                                  </tr>
                                )
                              })
                              : ''}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  : ""}
                {currentView === 'redFlag' ?
                  <div className='' >
                    {analysisData != null &&
                      analysisData != undefined &&
                      analysisData != '' && analysisData?.finBoxDecision != null && analysisData?.finBoxDecision != undefined && analysisData?.finBoxDecision != "" &&
                      analysisData?.finBoxDecision?.rejected != null &&
                      analysisData?.finBoxDecision?.rejected != '' &&
                      analysisData?.finBoxDecision?.rejected != undefined && analysisData?.finBoxDecision?.finalDecision == 'Rejected' ? (
                      <div className='red-table-new table-new'>
                        <table>
                          <thead>
                            <tr className='thead-class'>
                              <th>Account Type</th>
                              <th>OverDue Amount</th>
                              <th>Disburse Amount</th>
                              <th>Disburse Date</th>
                              <th>Account Status</th>
                              <th>Current Balance</th>
                              <th>Status</th>
                              <th>Matched Condition</th>
                            </tr>
                          </thead>
                          <tbody>
                            {analysisData != null &&
                              analysisData != undefined &&
                              analysisData != '' && analysisData?.finBoxDecision != null && analysisData?.finBoxDecision != undefined && analysisData?.finBoxDecision != ""
                              ? analysisData?.finBoxDecision?.rejected.map((data, i) => {
                                const messageType = data.disburseAmount;
                                const amount = data.status;

                                // const isEmiIncluded = jsondata['redFlag'] && jsondata['redFlag'].some(item => (item.disburseAmount === messageType) && (item.status === amount));

                                return (
                                  // <tr key={i} style={{
                                  //     background: isEmiIncluded ? 'lightgreen' : 'white', cursor: 'pointer'
                                  // }} onClick={() => crfJsonData('redFlag', data)}>
                                  <tr key={i}>
                                    <td>{data?.accountType ?? "-"}</td>
                                    <td>{data?.overDueAmount || "-"}</td>
                                    <td>{data?.disburseAmount || "-"}</td>
                                    <td>{data?.disburseDate ?? "-"}</td>
                                    <td>{data?.accountStatus ?? "-"}</td>
                                    <td>{data?.currentBalance || "-"}</td>
                                    <td>{data?.status ?? "-"}</td>
                                    {/* <td>{data?.matchedCondition}</td> */}
                                    <td>{data?.matchedCondition == 'Case 1' ? 'Suit-Filed/Willful/DBT/LSS/SMA & no sanctioning in last 3 Years' : data?.matchedCondition == 'Case 2' ? 'Write-off/Settled, DBT, LSS & SMA with amount > INR 5000 in last 2 years' : data?.matchedCondition == 'Case 3' ? 'Max DPD >= 90 in last 24 months with Balance > INR 5,000' : data?.matchedCondition == 'Case 4' ? 'DPD >= 5 in last 6 months with Balance/Overdue amount >INR 5,000' : data?.matchedCondition == 'Case 5' ? 'Current Sanctioning Exception Case & previous loan overdue' : ""}</td>

                                  </tr>
                                )
                              })
                              : ""}

                          </tbody>
                        </table>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  : ""}

                {currentView === 'detailed' ?
                  <div className="DetailedView">
                    <div className="btns">
                      <button className='button2' onClick={() => handleRegenerate()}>Regenerate CRIF</button>
                      <button className='button2 me-3' onClick={() => setshowReportPopup(true)}>View Full Report &nbsp;<i class="fa-solid fa-up-right-and-down-left-from-center"></i></button>
                    </div>

                    <div className="row mt-5">
                      {analysisData?.finBoxDecision?.finalDecision != null && currentView === 'detailed' ?
                        <div className="col-6">
                          <div className="Data d-flex justify-content-between align-items-center" style={{ border: analysisData?.finBoxDecision?.finalDecision === 'Rejected' ? '1px solid  #FF4444' : '1px solid var(--success, #00C851)', background: analysisData?.finBoxDecision?.finalDecision === 'Rejected' ? '#FEECEB' : 'var(--light-green, ##FEECEB)', padding: '10px', borderRadius: '6px' }}> {/* #FEECEB red */}
                            <h5 style={{ fontSize: '14px', margin: "10px 0px" }}>Automated Decision</h5>
                            <h4 style={{ color: analysisData.finalDecision === 'Rejected' ? 'red' : analysisData?.finBoxDecision?.finalDecision === 'Approved' ? 'green' : '#31311f', fontWeight: '700', fontSize: '16px', margin: "10px 0px" }}>{analysisData?.finBoxDecision?.finalDecision}</h4>
                            {analysisData?.finBoxDecision?.fetchDate ? <> Verified on - {analysisData?.finBoxDecision?.fetchDate ? moment(analysisData?.finBoxDecision?.fetchDate).format('DD-MM-YYYY') : ''}</> : ""}
                          </div>
                        </div>
                        : ''}
                      {analysisData?.finBoxDecision?.score != null && analysisData?.finBoxDecision?.score != "" && currentView === 'detailed' ?
                        <div className="col-6">
                          <div className="Data d-flex justify-content-between align-items-center" style={{ border: '1px solid rgb(38, 125, 255)', background: 'rgb(241, 247, 255)', padding: '10px', borderRadius: '6px' }}>
                            <h5 style={{ fontSize: '14px', margin: "10px 0px" }}>Cibil Score</h5>
                            <h5 style={{ fontSize: '16px', margin: "10px 0px", color: analysisData?.finBoxDecision?.score === 'Rejected' ? 'red' : analysisData?.finBoxDecision?.score === 'Approved' ? 'green' : '#31311f' }}>{analysisData?.finBoxDecision?.score}</h5>
                          </div>
                        </div>
                        : ''}
                    </div>
                    {analysisData != '' && analysisData != null && analysisData?.finBoxDecision != "" && analysisData?.finBoxDecision != null && currentView === 'detailed' ?
                      <div className="MatchData d-flex justify-content-between" style={{ background: "rgba(242, 242, 250, 0.8)", border: "1px solid #D3D9E9", marginTop: '15px', borderRadius: '4px', padding: '10px' }}>
                        <div className="Block text-center">
                          <h5 style={{ fontSize: '14px' }}>Dual Pan </h5>

                          {analysisData?.finBoxDecision?.dualPan == true ?

                            <img src={VerifyImage} width={"20px"} />
                            :
                            <img src={NotVerified} width={"20px"} />
                          }
                        </div>
                        <div className="Block text-center">
                          <h5 style={{ fontSize: '14px' }}>Mobile Matched</h5>
                          {analysisData?.finBoxDecision?.mobileMatched == true ?

                            <img src={VerifyImage} width={"20px"} />
                            :
                            <img src={NotVerified} width={"20px"} />
                          }
                        </div>
                        <div className="Block text-center">
                          <h5 style={{ fontSize: '14px' }}>Current Address Pincode Matched</h5>
                          {analysisData?.finBoxDecision?.currentAddressPincodeMatched == true ?

                            <img src={VerifyImage} width={"20px"} />
                            :
                            <img src={NotVerified} width={"20px"} />
                          }
                        </div>
                      </div>
                      : ''}
                  </div>
                  : ""}


                {
                  showReportPopup ?
                    <>
                      <div className='bg-grey' style={{ position: 'fixed', top: '0', bottom: '0', left: '0', right: '0', zIndex: '99', background: 'rgb(128 128 128 / 30%)' }}>
                        <div class="modal d-block" tabindex="-1" style={{ top: '4%' }}>
                          <div class="modal-dialog" style={{ maxWidth: '90%' }}>
                            <div class="modal-content">
                              <div class="modal-body">
                                <div className="DetailedView">
                                  <div className="btns">
                                    <button style={{ background: 'red', color: '#fff', border: 'none', borderTopRightRadius: '6px', position: "absolute", top: '0', right: '0' }} onClick={() => setshowReportPopup(false)}><i class="fa fa-times" aria-hidden="true"></i></button>
                                  </div>
                                  {
                                    crifData ?
                                      <button className='button2' onClick={() => DownloadReport()}><i class="fa fa-download" aria-hidden="true"></i> &nbsp;Download Report</button>
                                      : ''}

                                  <div className="row mt-4">
                                    {analysisData?.finBoxDecision?.finalDecision != null && currentView === 'detailed' ?
                                      <div className="col-6">
                                        <div className="Data d-flex justify-content-between align-items-center" style={{ border: analysisData?.finBoxDecision?.finalDecision === 'Rejected' ? '1px solid  #FF4444' : '1px solid var(--success, #00C851)', background: analysisData?.finBoxDecision?.finalDecision === 'Rejected' ? '#FEECEB' : 'var(--light-green, ##FEECEB)', padding: '10px', borderRadius: '6px' }}> {/* #FEECEB red */}
                                          <h5 style={{ fontSize: '14px', margin: "10px 0px" }}>Automated Decision</h5>
                                          <h4 style={{ color: analysisData.finalDecision === 'Rejected' ? 'red' : analysisData?.finBoxDecision?.finalDecision === 'Approved' ? 'green' : '#31311f', fontWeight: '700', fontSize: '16px', margin: "10px 0px" }}>{analysisData?.finBoxDecision?.finalDecision}</h4>
                                          {analysisData?.finBoxDecision?.fetchDate ? <> Verified on - {analysisData?.finBoxDecision?.fetchDate ? moment(analysisData?.finBoxDecision?.fetchDate).format('DD-MM-YYYY') : ''}</> : ""}
                                        </div>
                                      </div>
                                      : ''}
                                    {analysisData?.finBoxDecision?.score != null && analysisData?.finBoxDecision?.score != "" && currentView === 'detailed' ?
                                      <div className="col-6">
                                        <div className="Data d-flex justify-content-between align-items-center" style={{ border: '1px solid rgb(38, 125, 255)', background: 'rgb(241, 247, 255)', padding: '10px', borderRadius: '6px' }}>
                                          <h5 style={{ fontSize: '14px', margin: "10px 0px" }}>Cibil Score</h5>
                                          <h5 style={{ fontSize: '16px', margin: "10px 0px", color: analysisData?.finBoxDecision?.score === 'Rejected' ? 'red' : analysisData?.finBoxDecision?.score === 'Approved' ? 'green' : '#31311f' }}>{analysisData?.finBoxDecision?.score}</h5>
                                        </div>
                                      </div>
                                      : ''}
                                  </div>

                                  {analysisData != '' && analysisData != null && analysisData?.finBoxDecision != "" && analysisData?.finBoxDecision != null && currentView === 'detailed' ?
                                    <div className="MatchData d-flex justify-content-between" style={{ background: "rgba(242, 242, 250, 0.8)", border: "1px solid #D3D9E9", marginTop: '15px', borderRadius: '4px', padding: '10px' }}>
                                      <div className="Block text-center">
                                        <h5 style={{ fontSize: '14px' }}>Dual Pan </h5>

                                        {analysisData?.finBoxDecision?.dualPan == true ?

                                          <img src={VerifyImage} width={"20px"} />
                                          :
                                          <img src={NotVerified} width={"20px"} />
                                        }
                                      </div>
                                      <div className="Block text-center">
                                        <h5 style={{ fontSize: '14px' }}>Mobile Matched</h5>
                                        {analysisData?.finBoxDecision?.mobileMatched == true ?

                                          <img src={VerifyImage} width={"20px"} />
                                          :
                                          <img src={NotVerified} width={"20px"} />
                                        }
                                      </div>
                                      <div className="Block text-center">
                                        <h5 style={{ fontSize: '14px' }}>Current Address Pincode Matched</h5>
                                        {analysisData?.finBoxDecision?.currentAddressPincodeMatched == true ?

                                          <img src={VerifyImage} width={"20px"} />
                                          :
                                          <img src={NotVerified} width={"20px"} />
                                        }
                                      </div>
                                    </div>
                                    : ''}
                                  {
                                    crifData ?
                                      <div id="html-renderer" style={{ marginTop: '20px', height: window?.innerWidth > 1800 ? "650px" : "450px", overflowY: 'auto' }}>
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: crifData
                                          }}
                                        >
                                        </div>
                                      </div>
                                      :
                                      <p className='text-center mt-5'>
                                        <img src={noData} width={"30%"} />
                                      </p>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                    : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
